import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[in2CrHost]',
  standalone: false,
})
export class MainCouranteElementDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
